import { PRODUCT_EXTRA_COIN_DISPLAY_OVERRIDE } from '@configs/officialWebStore/globalGameInfoConfig';

const ROV371_PRODUCT_EXTRA_COIN_ICO =
  '//cdnimages.awselbcombine.com/public_images/one_image/2024/05/171584266376490469.png';

function resolveOverrideName(nameConfig, lang, defaultName) {
  if (!nameConfig) {
    return defaultName;
  }
  if (typeof nameConfig === 'string') {
    return nameConfig;
  }
  return nameConfig[lang] || nameConfig['en-US'] || defaultName;
}

/**
 * 开发商加码（PRODUCT_EXTRA_COIN）展示：371 特例 + config 覆写（currency 且有加码）
 * @returns {{ name: string, ico: string, isOverride: boolean }}
 */
export function getProductExtraCoinDisplay({
  gameId,
  product,
  lang = 'en-US',
  defaultName = '',
  defaultIco = ''
}) {
  const defaults = { name: defaultName, ico: defaultIco, isOverride: false };

  if (+gameId === 371 && +(product?.PRODUCT_EXTRA_COIN || 0) > 0) {
    return {
      name: 'Crystals',
      ico: ROV371_PRODUCT_EXTRA_COIN_ICO,
      isOverride: false
    };
  }

  const extraCoin = +(product?.PRODUCT_EXTRA_COIN || 0);
  const override = PRODUCT_EXTRA_COIN_DISPLAY_OVERRIDE[+gameId];
  if (
    override &&
    (product?.PRODUCT_TYPE || '') === 'currency' &&
    extraCoin > 0
  ) {
    return {
      name: resolveOverrideName(override.name, lang, defaultName),
      ico: override.icon ?? defaultIco,
      isOverride: true
    };
  }

  return defaults;
}
